import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('es-PA', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('es-PA', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatCoins(amount) {
  return new Intl.NumberFormat('es-PA').format(amount);
}

export function getStatusBadgeClass(status) {
  switch (status?.toUpperCase()) {
    case 'PENDING':
      return 'badge-pending';
    case 'APPROVED':
    case 'ACTIVE':
    case 'COMPLETED':
      return 'badge-approved';
    case 'REJECTED':
    case 'INACTIVE':
      return 'badge-rejected';
    default:
      return 'badge-pending';
  }
}

export function getStatusLabel(status) {
  switch (status?.toUpperCase()) {
    case 'PENDING':
      return 'Pendiente';
    case 'APPROVED':
      return 'Aprobado';
    case 'REJECTED':
      return 'Rechazado';
    case 'SOLD':
      return 'Vendido';
    case 'ACTIVE':
      return 'Activo';
    case 'INACTIVE':
      return 'Inactivo';
    default:
      return status;
  }
}

export function getLedgerTypeLabel(type) {
  switch (type) {
    case 'EARN':
      return 'Ganado';
    case 'ADJUSTMENT':
      return 'Ajuste';
    case 'PURCHASE':
      return 'Compra';
    case 'LISTING_SALE':
      return 'Venta';
    case 'LISTING_PURCHASE':
      return 'Compra Anuncio';
    case 'REFUND':
      return 'Reembolso';
    default:
      return type;
  }
}

export function getLedgerTypeColor(type) {
  switch (type) {
    case 'EARN':
      return 'text-emerald-600';
    case 'ADJUSTMENT':
      return 'text-blue-600';
    case 'PURCHASE':
    case 'LISTING_PURCHASE':
      return 'text-red-600';
    case 'LISTING_SALE':
    case 'REFUND':
      return 'text-emerald-600';
    default:
      return 'text-slate-600';
  }
}
